import React from 'react';
import { Box, Heading, Input, InputGroup, InputLeftElement, HStack, Button } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FiSearch } from 'react-icons/fi';
import {useAppData} from '../../store/dataStore';

const MotionBox = motion(Box);

const BlogHero = ({ searchQuery, setSearchQuery, selectedCategory, setSelectedCategory }) => {
  const categories = ['All', 'Guides', 'Tutorials', 'Career Advice', 'Industry Trends'];
  const { appData } = useAppData();
  const { studentsCount } = appData;

  return (
    <Box bg="brand.700" color="white" pt={24} pb={16}>
      <Box maxW="1200px" mx="auto" px={{ base: 4, md: 8 }}>
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          textAlign="center"
          mb={8}
        >
          <Heading as="h1" size="2xl" mb={4} fontFamily="heading">
            AI Insights & Resources
          </Heading>
        </MotionBox>

        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          maxW="600px"
          mx="auto"
          mb={6}
        >
          <InputGroup size="lg">
            <InputLeftElement pointerEvents="none">
              <FiSearch color="gray.400" />
            </InputLeftElement>
            <Input
              placeholder="Search articles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              bg="white"
              color="brand.800"
              // GA: search_query
            />
          </InputGroup>
        </MotionBox>

        <HStack 
          spacing={3} 
          justify="center" 
          flexWrap="wrap"
          gap={2}
        >
          {categories.map((category) => (
            <Button
              key={category}
              size="sm"
              variant={selectedCategory === category ? 'solid' : 'outline'}
              onClick={() => setSelectedCategory(category)}
              borderColor="white"
              color={selectedCategory === category ? 'brand.800' : 'white'}
              // GA: category_filter
            >
              {category}
            </Button>
          ))}
        </HStack>
      </Box>
    </Box>
  );
};

export default BlogHero;
